import { FETCH_CURRENT_GROUP_SUCCESS, FETCH_CURRENT_GROUP_PENDING, FETCH_CURRENT_GROUP_ERROR, RESET_CURRENT_GROUP, } from './constants';
const INITIAL_STATE = {
    currentGroup: null,
    isLoading: false,
    error: false,
};
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_CURRENT_GROUP_SUCCESS:
            return {
                currentGroup: action.payload,
                isLoading: false,
                error: false,
            };
        case FETCH_CURRENT_GROUP_PENDING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case FETCH_CURRENT_GROUP_ERROR:
            return {
                currentGroup: null,
                isLoading: false,
                error: true,
            };
        case RESET_CURRENT_GROUP:
            return INITIAL_STATE;
        default:
            return state;
    }
};
export default reducer;
